<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          <a href="#">{{translations('inventory.inventory_system')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('navbar.inventory_entry')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2" id="collapseExample">
        <div class="form-group mr-2 mt-1 d-flex align-items-center">
          <span class="text-nowrap mr-1">{{translations('inventory.inventory_date')}}</span>
          <input
            v-model="inventory_at"
            :disabled="disableDifference"
            type="date"
            class="form-control input-150px"
            @change="confirmDateAt"
          />
          <input
            v-model="timeInventoryAt"
            type="time"
            class="form-control input-time"
          >
        </div>
        <div class="form-group mr-2 mt-1">
          <div class="dropdown">
            <button
              id="filterByWarehouse"
              class="btn btn-outline-secondary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="disableDifference"
            >
              {{ selectWarehouse(warehouse_id) }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" @click="selectDefaultWarehouse">{{translations('inventory.select_warehouse')}}</a>
              <a
                class="dropdown-item"
                v-for="(warehouse, i) in warehouses"
                :key="i"
                @click="confirmWarehouse(warehouse.id)"
                >{{ selectWarehouse(warehouse.id) }}</a
              >
            </div>
          </div>
        </div>
        <div
          class="form-group mr-2 mt-1"
          v-for="(condition, i) in conditions"
          :key="i"
        >
          <div class="form-check">
            <input
              v-model="selectedCondition"
              :id="condition.id"
              class="form-check-input pointer-clickable"
              type="radio"
              :value="condition.value"
              @click="confirmCondition"
              @change="changeCondition"
              :disabled="disableDifference"
            />
            <label
              class="form-check-label pointer-clickable"
              :for="condition.id"
            >
              {{ condition.name }}
            </label>
          </div>
        </div>
        <div class="form-group mr-1 ml-4 mt-1">
          <div class="dropdown">
            <button
              id="filterByStatus"
              class="btn btn-outline-secondary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="disableDifference"
            >
              {{ selectStatus(status_id) }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" @click="selectDefaultStatus">{{ translations('inventory.estimation_status') }}</a>
              <a
                class="dropdown-item"
                v-for="(status, i) in statuses"
                :key="i"
                @click="confirmStatus(status.id)"
                >{{ selectStatus(status.id) }}</a
              >
            </div>
          </div>
        </div>
        <div class="form-group mr-1 mt-1">
          <div class="dropdown">
            <button
              id="filterByPersonal"
              class="btn btn-outline-secondary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ selectPersonal(personal_id) }}
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                v-for="(personal, i) in personals"
                :key="i"
                @click="changePersonal(personal.id)"
                >{{ selectPersonal(personal.id) }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="isDifference || isChangeStatus || isDifferenceLocal" class="form-group mr-1 mt-1">
          <input
            v-model="dtSearch"
            id="dtSearch"
            type="text"
            class="form-control input-150px"
            :placeholder="translations('common.keyword_search')"
          />
        </div>
        <!-- <div v-else class="form-group mr-1 mt-1">
          <input
            v-model="globalSearch"
            id="globalSearch"
            type="text"
            class="form-control input-150px"
            placeholder="キーワード検索"
            @keyup.enter="confirmGlobalSearch"
          />
        </div> -->
        <div class="form-group mr-1 mt-1">
          <input
            type="file"
            ref="file"
            @change="handleFileUpload($event)"
            class="d-none"
          />
          <button
            :disabled="disableDifference"
            @click="openImportForm"
            class="btn btn-outline-secondary"
            type="button"
          >
            {{ translations('inventory.import') }}
          </button>
        </div>
        <div class="form-group mr-1 mt-1">
          <button
            class="btn btn-outline-secondary"
            type="button"
            :disabled="disableDifference"
            @click="sumInventories"
          >
            {{ translations('inventory.calculation') }}
          </button>
        </div>
        <div v-if="isScanBarCode" class="form-group mr-1 mt-1">
          <button
            class="btn btn-outline-secondary"
            type="button"
            :class="{ 'border-danger': isDifferenceLocal }"
            @click="isDifferenceLocal ? cancelDifferenceLocal() : getDiffInventoryLocal()"
          >
            {{ isDifferenceLocal ? translations('inventory.return') : translations('inventory.detect_difference') }}
          </button>
        </div>
        <div v-else class="form-group mr-1 mt-1">
          <button
            class="btn btn-outline-secondary"
            type="button"
            :class="{ 'border-danger': isDifference }"
            @click="isDifference ? cancelDifference() : confirmGetDiffInventory()"
          >
            {{ isDifferenceLocal ? translations('inventory.return') : translations('inventory.detect_difference') }}
          </button>
        </div>
        <div class="form-group mr-1 mt-1">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="submitCheckInventory"
            :disabled="hasOutOfStock"
          >
            {{ translations('inventory.inventory_confirm_regis') }}
          </button>
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
        </div>
        <div>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-4 pt-4">
        <div class="left-container-sm">
          <div class="checkbar-group form-group mr-3 ml-3">
            <label class="checkbar-label">
              <span>{{ translations('inventory.jancode_scan') }}</span>
              <span>{{ translations('inventory.model_input') }}</span>
            </label>
            <div>
              <input
                v-model="barCode"
                :disabled="disableDifference"
                ref="barCodeSearch"
                type="text"
                class="form-control input-barcode"
                @keyup.enter="confirmSearchBarCode"
              />
            </div>
          </div>
        </div>
        <div class="right-container-sm">
          <div class="table-scroll">
            <v-data-table
              class="
                table
                table-striped
                table-hover
                table-clickable
                table-800
                table-align-middle
              "
              item-key="name"
              :search="dtSearch"
              :headers="translatedHeaders"
              hide-default-footer
              :items="filterInventories"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
              @current-items="currentItems"
            >
              <template v-slot:body="{ items }">
                <tbody class="nowrap">
                  <tr v-for="(inventory, i) in items" :key="i">
                    <td>{{ inventory.jan_code }}</td>
                    <td>{{ inventory.item_no }}</td>
                    <td>{{ inventory.legacy_code }}</td>
                    <td>{{ inventory.type_number }}</td>
                    <td>
                      <div class="width-80-px">
                        <input
                          v-model="inventory.real_quantity"
                          type="text"
                          class="form-control"
                          :class="{ 'border-danger': inventory.isValidNumber }"
                          width="20px"
                          :ref="'actual-number-' + i"
                          @change="changeRealQuantity($event, inventory, i)"
                          @keyup.enter="enterActualNumber(i)"
                        />
                      </div>
                    </td>
                    <td>{{ inventory.amount }}</td>
                    <td>
                      <div>
                        {{ inventory.real_quantity - inventory.amount || 0 }}
                      </div>
                    </td>
                    <td v-if="isDifference">
                      <div class="wrap-edit">
                        <div class="show-text">
                          {{ inventory.note }}
                        </div>
                        <textarea
                          v-model="inventory.note"
                          type="text"
                          class="form-control edit-input"
                          rows="1"
                          @blur="($event) => {$event.target.style.height = 'auto'}"
                          @focus="resize"
                          @input="resize($event)"
                          :ref="'note-' + i"
                        />
                      </div>
                    </td>
                    <td v-if="inventory.out_of_stock" style="color: red; width: 10px">{{ translations('inventory.notice_order_reserve') }}</td>
                    <td v-else></td>
                  </tr>
                  <tr class="odd" v-if="isEmpty">
                    <td valign="top" colspan="13" class="dataTables_empty">{{translations('inventory.data_not_found')}}</td>
                  </tr>
                  <tr v-if="!isDifference">
                    <td><span class="font-weight-bold">{{translations('inventory.total')}}:</span></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <span class="real-quantity">
                        {{ totalRealQuantity }}
                      </span>
                    </td>
                    <td>
                      <span class="font-weight-bold">
                        {{ totalOriginalQuantity }}
                      </span>
                    </td>
                    <td>
                      <span class="font-weight-bold">
                        {{ totalRealQuantity - totalOriginalQuantity }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
          <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4"></v-pagination>
        </div>
      </div>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true" />
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { inventoryStatus } from '../constants'

import { saveAs } from 'file-saver'
import { format } from 'date-fns'
import { mapState } from 'vuex'

var PapaParse = require('papaparse')
var encoding = require('encoding-japanese')

export default {
  name: 'CheckInventories',
  components: {
    VueElementLoading
  },
  watch: {
    dtSearch (val) {
      this.$storage.set('CheckInventories:dtSearch', val) // KEEP KEYWORD
    },
    warehouse_id (val) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.warehouses_id = val
      this.$storage.set('CheckInventoriesParam', params)
    },
    status_id (val) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.status_id = val
      this.$storage.set('CheckInventoriesParam', params)
    },
    personal_id (val) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.personal_id = val
      this.$storage.set('CheckInventoriesParam', params)
    },
    inventory_at (val, oldVal) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.inventory_at = val
      params.old_inventory_at = oldVal
      this.$storage.set('CheckInventoriesParam', params)
    },
    selectedCondition (val, oldVal) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.selectedCondition = val
      params.selectedOldCondition = oldVal
      this.$storage.set('CheckInventoriesParam', params)
    },
    isDifferenceLocal (val) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.isDifferenceLocal = val
      this.$storage.set('CheckInventoriesParam', params)
    },
    isDifference (val) {
      let params = this.$storage.get('CheckInventoriesParam')
      if (!params) params = {}
      params.isDifference = val
      this.$storage.set('CheckInventoriesParam', params)
    },
    currentLanguage (newLang, oldLang) {
      this.listStatuses()
      this.updateConditions()
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('CheckInventories:dtSearch') || '',
      globalSearch: '',
      isGlobalSearching: false,
      isSearching: false,
      isDifference: false,
      isChangeStatus: false,
      isEmpty: false,
      isSavingSession: false,
      isScanBarCode: true,
      isDifferenceLocal: false,
      inventory_at: null,
      timeInventoryAt: format(new Date(), 'HH:mm'),
      tempDateField: null,
      timeOutId: null,
      listKeyFilter: [],
      warehouses: [],
      warehouse_id: 0,
      statuses: [],
      status_id: 0,
      personals: [],
      personal_id: Number(this.$store.getters['User/id']),
      inventories: [],
      tempInventories: [],
      inventoryChangeMap: new Map(),
      searchInventories: [],
      page: 1,
      pageCount: null,
      itemsPerPage: 10,
      conditions: [],
      selectedCondition: 0,
      barCode: '',
      csvFile: '',
      isCsvFile: false,
      editHeader: { text: 'ノート', value: '' },
      msgConfirm: {
        title: '変更しますか。',
        body: '表示している結果が無くなる可能性があります。ご注意してください。'
      },
      optionConfirm: {
        okText: '続き',
        cancelText: 'キャンセル'
      }
    }
  },
  created: async function () {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
    this.$storage.remove('CheckInventories:barCode')
    this.isSearching = true
    await this.listWarehouses()
    await this.listStatuses()
    await this.listPersonals()
    this.updateConditions()

    let storedFilter = this.$storage.get('CheckInventoriesParam')
    if (storedFilter) {
      this.personal_id = storedFilter.personal_id || Number(this.$store.getters['User/id'])
      this.warehouse_id = storedFilter.warehouses_id || 0
      this.status_id = storedFilter.status_id || 0
      this.inventory_at = storedFilter.inventory_at
      this.selectedCondition = storedFilter.selectedCondition || 0
      this.isDifference = storedFilter.isDifference || false
      this.isDifferenceLocal = storedFilter.isDifferenceLocal || false
    }

    if (!this.inventory_at) this.inventory_at = this.$invoiceTools.getCurrentDate()

    if (this.status_id > 0) await this.changeStatus(this.status_id)

    if (this.isDifference) {
      await this.getDiffInventory()
      this.isScanBarCode = false
    }

    // await this.getCacheDataWithFilter()
    if (this.isDifferenceLocal) this.getDiffInventoryLocal()

    this.isSearching = false
  },
  mounted: function () {
    this.focusBarcodeInput()
  },
  beforeDestroy: function () {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  computed: {
    ...mapState(['currentLanguage']),
    translatedHeaders () {
      const headers = [
        { text: 'inventory.jan_code', value: 'jan_code' },
        { text: 'inventory.item_no', value: 'item_no' },
        { text: 'inventory.legacy_code', value: 'legacy_code' },
        { text: 'inventory.model', value: 'type_number' },
        { text: 'inventory.actual_quantity', value: '' },
        { text: 'inventory.ledger_count', value: '' },
        { text: 'inventory.discrepancy_number', value: '' },
        { text: '', value: '', sortable: false }
      ]
      return headers.map(header => ({
        ...header,
        text: this.translations(header.text)
      }))
    },
    selectWarehouse () {
      return (warehouseId) => {
        const warehouse = this.warehouses.find((w) => w.id === warehouseId)
        if (!warehouse) return this.translations('inventory.select_warehouse')
        return warehouse.name
      }
    },
    selectStatus () {
      return (statusId) => {
        const status = this.statuses.find((s) => s.id === statusId)
        if (!status) return this.translations('inventory.estimation_status')
        return status.name
      }
    },
    selectPersonal () {
      return (personalId) => {
        const personal = this.personals.find((p) => p.id === personalId)
        if (!personal) return this.translations('inventory.manager')
        return personal.name
      }
    },
    filterInventories () {
      let inventories = this.inventories

      // 棚卸し日
      if (Number(this.status_id) > 0) {
        inventories = inventories.filter(inventory => {
          return this.getStatusId(inventory.inventory_checked_at) === Number(this.status_id)
        })
      }

      return inventories
    },

    totalRealQuantity () {
      const inventories = (this.dtSearch === '' && this.searchInventories.length) ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.real_quantity) || 0), 0)
    },

    totalOriginalQuantity () {
      const inventories = (this.dtSearch === '' && this.searchInventories.length) ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.amount) || 0), 0)
    },

    isConfirm () {
      return this.filterInventories.length !== 0 && this.inventoryChangeMap.size
    },

    disableDifference () {
      return this.isDifference || this.isDifferenceLocal
    },

    hasOutOfStock () {
      return this.inventories.some(inventory => inventory.out_of_stock === true)
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    filterPropInventory (inventories) {
      return inventories.map((inventory) => {
        return {
          amount: inventory.amount,
          id: inventory.id,
          inventory_checked_at: inventory.inventory_checked_at,
          item_no: inventory.item_no,
          jan_code: inventory.jan_code,
          legacy_code: inventory.legacy_code,
          note: null,
          personal_id: this.personal_id,
          process_status: inventory.process_status,
          product_id: inventory.product_id,
          real_quantity: inventory.real_quantity,
          quantity: inventory.real_quantity,
          type_number: inventory.type_number,
          warehouse_id: this.warehouse_id,
          condition_id: inventory.condition_id,
          condition: inventory.condition_id,
          original_quantity: inventory.original_quantity,
          date: this.inventory_at,
          reserve_quantity: inventory.reserve_quantity
        }
      })
    },

    initList () {
      if (this.page !== 1) this.page = 1
    },

    async listWarehouses () {
      try {
        let cList = await this.$http.post(this.$api_url.warehouse_list)
        const { data, success } = this.$invoiceTools.prepareResult(
          cList.data,
          'list',
          'CheckInventories:listWarehouses'
        )
        this.warehouses = success ? data : [{ id: 0, name: 'No record.' }]
      } catch (error) {
        console.log(
          'CheckInventories:listWarehouses:catch(error): ',
          JSON.stringify(error)
        )
        this.$toastr.error(
          this.translations('inventory.notice_failed'),
          this.translations('common.error')
        )
      }
    },

    async listStatuses () {
      try {
        let cList = await this.$http.post(this.$api_url.inventory_status_list)
        const { data, success } = this.$invoiceTools.prepareResult(
          cList.data,
          'list',
          'CheckInventories:listWarehouses'
        )
        const translatedStatuses = success ? this.translateStatuses(data) : [{ id: 0, name: 'No record.' }]
        this.statuses = translatedStatuses
      } catch (error) {
        console.log(
          'CheckInventories:listStatuses:catch(error): ',
          JSON.stringify(error)
        )
        this.$toastr.error(
          this.translations('inventory.notice_failed'),
          this.translations('common.error')
        )
      }
    },

    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },

    updateConditions () {
      this.conditions = [
        { id: 'good', name: this.translations('inventory.good'), value: 0 },
        { id: 'bad', name: this.translations('inventory.bad'), value: 1 },
        { id: 'outlet', name: this.translations('inventory.outlet'), value: 2 }
      ]
    },

    async listPersonals () {
      try {
        let cList = await this.$http.post(
          this.$api_url.inventory_personal_list
        )
        const { data, success } = this.$invoiceTools.prepareResult(
          cList.data,
          'list',
          'CheckInventories:listWarehouses'
        )
        this.personals = success ? data : [{ id: 0, name: 'No record.' }]
      } catch (error) {
        console.log(
          'CheckInventories:listPersonals:catch(error): ',
          JSON.stringify(error)
        )
        this.$toastr.error(
          this.translations('inventory.notice_failed'),
          this.translations('common.error')
        )
      }
    },

    async listInventories () {
      if (!this.warehouse_id || !this.inventory_at) {
        return
      }
      this.isSearching = true
      try {
        const params = {
          warehouses_id: this.warehouse_id,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition,
          personal_id: this.personal_id,
          process_status: this.status_id
        }
        let inventoriesList = await this.$http.post(this.$api_url.inventory_list, params)
        const { success, data } = this.$invoiceTools.prepareResult(inventoriesList.data, 'list', 'CheckInventories:listInventories')
        if (success) {
          data.forEach((item) => {
            item.condition_id = this.selectedCondition
            item.original_quantity = item.real_quantity
          })
          this.inventories = data
        } else {
          this.inventories = []
          this.$toastr.error(data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('CheckInventories:listInventories:catch(error): ', JSON.stringify(error))
        this.$toastr.error(this.translations('inventory.notice_failed'), this.translations('common.error'))
      }
      this.isSearching = false
    },

    confirmDateAt () {
      if (this.timeOutId) clearTimeout(this.timeOutId)
      let storedFilter = this.$storage.get('CheckInventoriesParam')
      this.inventory_at = storedFilter.old_inventory_at
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.inventory_at = storedFilter.inventory_at
      this.inventories = []
      if (this.isChangeStatus) {
        this.selectedCondition = this.conditions[0].value
        this.status_id = 0
        this.isChangeStatus = false
      }
      this.isEmpty = false
      this.setDisplayDiffBtn()
      this.inventoryChangeMap.clear()
      this.setDefaultInputBarCode()
      this.focusBarcodeInput()
    },

    selectDefaultWarehouse () {
      if (this.timeOutId) clearTimeout(this.timeOutId)
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.warehouse_id = 0
      this.inventories = []
    },

    confirmWarehouse (warehouseId) {
      if (this.timeOutId) clearTimeout(this.timeOutId)
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.warehouse_id = warehouseId
      this.inventories = []
      if (this.isChangeStatus) {
        this.selectedCondition = this.conditions[0].value
        this.status_id = 0
        this.isEmpty = false
        this.isChangeStatus = false
      }
      this.setDisplayDiffBtn()
      this.setDefaultInputBarCode()
      this.focusBarcodeInput()
    },

    changeCondition () {
      this.$nextTick(async () => {
        this.setDisplayDiffBtn()
      })
    },

    confirmCondition () {
      if (this.timeOutId) clearTimeout(this.timeOutId)
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      // this.inventories = []
      this.isEmpty = false
      this.setDefaultInputBarCode()
      this.focusBarcodeInput()
      if (this.isChangeStatus) {
        // this.status_id = 0
        this.isChangeStatus = false
      }
    },

    setDefaultInputBarCode () {
      this.barCode = ''
      this.$storage.set('CheckInventories:barCode', this.barCode)
    },

    getStatusId (date) {
      if (!date) return inventoryStatus.UNTREATED
      if (!this.tempDateField) return inventoryStatus.PROCESSED
      return (date >= this.tempDateField) ? inventoryStatus.PROCESSED : inventoryStatus.UNTREATED
    },

    selectDefaultStatus () {
      if (this.timeOutId) clearTimeout(this.timeOutId)
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.isChangeStatus = false
      this.status_id = 0
      // this.inventories = []
      this.isEmpty = false
      this.initList()
      this.setDefaultInputBarCode()
      this.setDisplayDiffBtn()
    },

    confirmStatus (statusId) {
      if (!this.warehouse_id) {
        this.$toastr.error(this.translations('inventory.notice_select_warehouse'))
        return
      }

      if (!this.inventory_at) {
        this.$toastr.error(this.translations('inventory.notice_inventory_date'))
        return
      }

      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.changeStatus(statusId)
    },

    changePersonal (personalId) {
      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()
      this.personal_id = personalId
      if (this.isChangeStatus) {
        this.initList()
        this.changeStatus(this.status_id)
      }
    },

    changeStatus (statusId) {
      this.setDefaultInputBarCode()
      this.status_id = statusId
      this.tempDateField = this.inventory_at
      if (this.status_id === inventoryStatus.UNTREATED) {
        this.filterInventories.forEach((item) => {
          item.real_quantity = ''
          item.original_quantity = item.real_quantity
        })
      }
      this.isChangeStatus = true
      this.isScanBarCode = false
      this.isEmpty = !this.filterInventories.length
      this.dtSearch = ''
      this.globalSearch = ''
    },

    focusBarcodeInput () {
      this.$refs.barCodeSearch.focus()
    },

    focusActualNumber () {
      if (this.$refs['actual-number-0'][0]) this.$refs['actual-number-0'][0].focus()
    },

    enterActualNumber (i) {
      const inputActualNumber = this.$refs[`actual-number-${i + 1}`]
      this.$nextTick(() => {
        if (inputActualNumber && inputActualNumber.length && inputActualNumber[0].value === '') {
          inputActualNumber[0].focus()
        } else {
          this.focusBarcodeInput()
        }
      })
    },

    confirmSearchBarCode () {
      if (!this.warehouse_id) {
        this.$toastr.error(this.translations('inventory.notice_select_warehouse'))
        return
      }

      if (!this.inventory_at) {
        this.$toastr.error(this.translations('inventory.notice_inventory_date'))
        return
      }

      if (this.barCode === '') {
        return
      }

      this.$nextTick(async () => {
        if (this.barCode !== '') {
          this.parseBarcode()
        }
      })
    },

    async parseBarcode () {
      this.$storage.set('CheckInventories:barCode', this.barCode)

      if (this.isChangeStatus) {
        this.inventories = []
        this.status_id = 0
        this.isChangeStatus = false
      }

      this.isSearching = true
      try {
        const params = {
          inventory_at: format(new Date(`${this.inventory_at} ${this.timeInventoryAt}`), "yyyy-MM-dd'T'HH:mm:59"),
          condition: this.selectedCondition,
          jan_code: this.barCode,
          warehouses_id: this.warehouse_id
        }
        let response = await this.$http.post(
          this.$api_url.inventory_list,
          params
        )

        const { success, data } = this.$invoiceTools.prepareResult(
          response.data,
          'list',
          'CheckInventories:listInventoriesCheckBar'
        )
        if (success) {
          data.forEach((item) => {
            item.condition_id = this.selectedCondition
            item.real_quantity = ''
            item.original_quantity = item.real_quantity
          })
          if (this.isGlobalSearching) {
            this.inventories = []
            this.isGlobalSearching = false
          }
          this.inventories = this.filterPropInventory(data).concat(this.inventories)
          this.$nextTick(this.focusActualNumber)
          this.isEmpty = !this.filterInventories.length
          this.isScanBarCode = true
        } else {
          this.$toastr.error(data)
        }
      } catch (error) {}
      this.barCode = ''
      this.dtSearch = ''
      this.isSearching = false
    },

    async submitCheckInventory () {
      if (!this.personal_id) {
        this.$toastr.error(this.translations('inventory.notice_enter_contact_person'))
        return
      }

      if (!this.filterInventories.length) {
        this.$toastr.error(this.translations('inventory.notice_no_data_entered'))
        return
      }

      const countError = this.filterInventories.reduce((prevValue, item) => {
        if (item.isValidNumber) prevValue++
        return prevValue
      }, 0)

      if (countError) {
        this.$toastr.error(this.translations('inventory.notice_check_actual_number'))
        return
      }

      for (let i = this.filterInventories.length - 1; i >= 0; i--) {
        if (this.filterInventories[i].real_quantity === '') this.filterInventories.splice(i, 1)
      }

      if (this.timeOutId) clearTimeout(this.timeOutId)

      this.isSearching = true

      if (this.isDifferenceLocal) this.cancelDifferenceLocal()

      if (this.status_id === 0) this.sumInventories()

      await this.saveDataWhenFilter()

      const params = {
        date: format(new Date(`${this.inventory_at} ${this.timeInventoryAt}`), "yyyy-MM-dd'T'HH:mm:59")
      }

      try {
        let response = await this.$http.post(
          this.$api_url.update_check_inventory,
          params
        )
        const { error, errorMsg, successMsg } = response.data.data
        if (!error) {
          this.setDefaultMode()
          this.$toastr.success(successMsg)
        } else {
          this.$toastr.error(errorMsg)
        }
      } catch (error) {}
      this.isSearching = false
    },

    setDefaultMode () {
      this.status_id = 0
      this.personal_id = Number(this.$store.getters['User/id'])
      this.dtSearch = ''
      this.globalSearch = ''
      this.isScanBarCode = false
      this.isDifference = false
      this.isDifferenceLocal = false
      this.inventories = []
      this.tempInventories = []
      this.setDefaultInputBarCode()
      this.focusBarcodeInput()
      this.inventoryChangeMap.clear()
      if (this.headers.indexOf(this.editHeader) !== -1) this.headers.pop(this.editHeader)
    },

    setDisplayDiffBtn () {
      this.isScanBarCode = !!this.filterInventories.length
    },

    openImportForm () {
      if (!this.warehouse_id) {
        this.$toastr.error(this.translations('inventory.notice_select_warehouse'))
        return
      }

      if (!this.inventory_at) {
        this.$toastr.error(this.translations('inventory.notice_inventory_date'))
        return
      }

      if (!this.personal_id) {
        this.$toastr.error(this.translations('inventory.notice_enter_contact_person'))
        return
      }
      this.$refs.file.click()
    },

    async handleFileUpload (event) {
      this.csvFile = event.target.files[0]
      this.isCsvFile = this.csvFile ? this.csvFile.type === 'text/csv' : false

      if (this.isCsvFile) {
        let formData = new FormData()
        formData.append('file', this.csvFile)
        formData.append('warehouse_id', this.warehouse_id)
        formData.append('inventory_at', format(new Date(`${this.inventory_at} ${this.timeInventoryAt}`), "yyyy-MM-dd'T'HH:mm:ss"))
        formData.append('user_id', this.personal_id)
        formData.append('condition', this.selectedCondition)
        this.isSearching = true

        try {
          let response = await this.$http.post(
            this.$api_url.import_csv_inventory,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          const { status, message } = response.data
          if (status) {
            const { errors, header, successMsg } = response.data.data
            this.$toastr.success(successMsg)
            this.csvFile = ''
            this.$refs.file.value = ''
            if (errors.length) {
              this.export_csv(header, errors)
              this.$toastr.error(this.translations('inventory.notice_cannot_be_imported'))
            }
          } else {
            this.$toastr.error(message)
            this.csvFile = ''
            this.$refs.file.value = ''
          }
        } catch (error) {
        }

        this.isSearching = false
      } else if (this.csvFile) {
        this.$toastr.error(this.translations('inventory.notice_check_import_file'), this.translations('common.error'))
        this.csvFile = ''
        this.$refs.file.value = ''
      }
    },

    export_csv (headers, errors) {
      const csvFieldKeys = Object.keys(errors[0].record)

      const csvData = errors.reduce((prevItem, item) => {
        const csvTemp = []
        csvFieldKeys.map((key) => {
          csvTemp.push(item.record[key])
        })
        prevItem.push(csvTemp)
        return prevItem
      }, [])

      const csv = PapaParse.unparse({
        fields: [...headers, '理由'],
        data: csvData
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'UTF8', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([
        new Uint8Array([0xEF, 0xBB, 0xBF]), uInt8List
      ], { type: 'text/csv' })

      const filename = `棚卸し ${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`

      saveAs(content, filename)
    },

    sumInventories () {
      let result = []

      if (this.status_id === 0) {
        this.filterInventories.forEach(function (inventory) {
          if (!this[inventory.id]) {
            this[inventory.id] = {
              real_quantity: 0,
              amount: inventory.amount,
              id: inventory.id,
              inventory_checked_at: inventory.inventory_checked_at,
              item_no: inventory.item_no,
              jan_code: inventory.jan_code,
              legacy_code: inventory.legacy_code,
              note: inventory.note,
              process_status: inventory.process_status,
              product_id: inventory.product_id,
              quantity: inventory.real_quantity,
              type_number: inventory.type_number,
              condition_id: inventory.condition_id,
              condition: inventory.condition_id,
              original_quantity: inventory.original_quantity
            }
            result.push(this[inventory.id])
          }
          this[inventory.id].real_quantity += Number(inventory.real_quantity)
        }, Object.create(null))

        this.inventories = result
      }
    },

    confirmGetDiffInventory () {
      if (!this.warehouse_id) {
        this.$toastr.error(this.translations('inventory.notice_select_warehouse'))
        return
      }

      if (!this.inventory_at) {
        this.$toastr.error(this.translations('inventory.notice_inventory_date'))
        return
      }

      if (this.filterInventories && this.filterInventories.length) this.saveDataWhenFilter()

      if (this.timeOutId) clearTimeout(this.timeOutId)

      this.getDiffInventory()
    },

    cancelDifferenceLocal () {
      let dataChange = this.filterInventories.filter((inventory) => inventory.real_quantity !== inventory.original_quantity)
      let dataNoExist = this.tempInventories.filter((inventory) => {
        return (inventory.real_quantity - inventory.amount) === 0
      })
      this.inventories = this.mergeArrays(dataNoExist.concat(dataChange), ['jan_code', 'item_no', 'legacy_code', 'amount'])
      this.tempInventories = []
      this.isDifferenceLocal = false
      this.dtSearch = ''
      this.globalSearch = ''
    },

    async getDiffInventoryLocal () {
      this.isSearching = true
      this.tempInventories = JSON.parse(JSON.stringify(this.filterInventories))

      const diffInventory = this.filterInventories.reduce((prevItem, curItem) => {
        if ((Number(curItem.real_quantity) - Number(curItem.amount) !== 0)) prevItem.push(curItem)
        return prevItem
      }, [])

      try {
        const params = {
          warehouses_id: this.warehouse_id,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition
        }

        let response = await this.$http.post(
          this.$api_url.diff_inventory,
          params
        )

        const { success, data } = this.$invoiceTools.prepareResult(
          response.data,
          'list',
          'CheckInventories:listDiffInventories'
        )

        if (success) {
          this.isEmpty = false
          this.status_id = 0
          data.forEach((item) => {
            item.condition_id = this.selectedCondition
            item.original_quantity = item.real_quantity
          })
          for (let i = data.length - 1; i >= 0; i--) {
            let isExistData = this.tempInventories.some(
              (elem) => elem.id === data[i].id
            )
            if (isExistData) data.splice(i, 1)
          }
          this.inventories = diffInventory.concat(data)
          this.isDifferenceLocal = true
        } else {
          if (diffInventory.length) {
            this.inventories = diffInventory
            this.isDifferenceLocal = true
          } else {
            this.$toastr.error(data)
          }
        }
      } catch (error) {}
      this.isSearching = false
    },

    cancelDifference () {
      this.inventories = []
      this.status_id = 0
      this.isDifference = false
      this.isChangeStatus = false
      this.dtSearch = ''
      this.globalSearch = ''
      this.inventoryChangeMap.clear()
      if (this.headers.indexOf(this.editHeader) !== -1) this.headers.pop(this.editHeader)
    },

    async getDiffInventory () {
      this.isSearching = true
      this.tempDateField = this.inventory_at
      try {
        const params = {
          warehouses_id: this.warehouse_id,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition
        }

        let response = await this.$http.post(
          this.$api_url.diff_inventory,
          params
        )

        const { success, data } = this.$invoiceTools.prepareResult(
          response.data,
          'list',
          'CheckInventories:listDiffInventories'
        )
        if (success) {
          this.isEmpty = false
          this.status_id = 0
          data.forEach((item) => {
            item.condition_id = this.selectedCondition
            item.original_quantity = item.real_quantity
          })
          this.inventories = data
          if (this.headers.indexOf(this.editHeader) === -1) this.headers.push(this.editHeader)
          this.isDifference = true
          this.setDefaultInputBarCode()
        } else {
          this.inventories = []
          this.isEmpty = true
          this.$toastr.error(data)
        }
      } catch (error) {}
      this.dtSearch = ''
      this.globalSearch = ''
      this.isSearching = false
    },

    resize (e) {
      setTimeout(() => { e.target.selectionStart = e.target.selectionEnd = e.target.value.length }, 0)
      e.target.style.height = 'auto'
      const { scrollHeight, clientHeight } = e.target
      if (scrollHeight > clientHeight) {
        e.target.style.height = scrollHeight + 'px'
      }
    },

    currentItems (value) {
      this.searchInventories = value
    },

    changeRealQuantity (e, inventory, index) {
      this.debounceSaveSession()
      const old = this.inventories[index]
      const { value } = e.target
      const isNullValue = !value && old.original_quantity
      const isChangeValue = value && Number(value) !== Number(inventory.original_quantity)
      const isZeroValue = parseInt(value) === 0 && inventory.original_quantity === ''
      if (isNullValue || isChangeValue || isZeroValue) {
        this.inventoryChangeMap.set(old.product_id, value)
      } else {
        this.inventoryChangeMap.delete(old.product_id)
      }

      const regex = /^(?:[0-9]\d*$)|(?:^0)$/
      const indexPageFilter = (this.page - 1) * this.itemsPerPage + index
      const newInventory = this.filterInventories[indexPageFilter]
      if (regex.test(value) && value) {
        e.target.classList.remove('border-danger')
        this.$set(newInventory, 'isValidNumber', false)
      } else {
        e.target.value = ''
        inventory.real_quantity = ''
        this.$set(newInventory, 'isValidNumber', true)
        this.$toastr.error(this.translations('inventory.notice_check_actual_number'))
      }
    },

    async confirmGlobalSearch () {
      if (!this.warehouse_id) {
        this.$toastr.error(this.translations('inventory.notice_select_warehouse'))
        return
      }

      if (!this.inventory_at) {
        this.$toastr.error(this.translations('inventory.notice_inventory_date'))
        return
      }
      this.triggerGlobalSearch()
    },

    async triggerGlobalSearch () {
      this.isSearching = true
      try {
        const params = {
          inventory_at: this.inventory_at,
          condition: this.selectedCondition,
          search: this.globalSearch,
          warehouses_id: this.warehouse_id
        }
        let response = await this.$http.post(
          this.$api_url.inventory_list,
          params
        )

        const { success, data } = this.$invoiceTools.prepareResult(
          response.data,
          'list',
          'CheckInventories:listInventoriesGlobalSearch'
        )
        if (success) {
          data.forEach((item) => {
            item.condition_id = this.selectedCondition
            item.real_quantity = (this.inventory_at === item.inventory_checked_at) ? item.real_quantity : 0
            item.original_quantity = item.real_quantity
          })
          this.inventories = data
          this.isEmpty = !this.filterInventories.length
          if (!this.isEmpty) this.isGlobalSearching = true
        } else {
          this.inventories = []
          this.$toastr.error(data)
        }
      } catch (error) {}
      this.barCode = ''
      this.isSearching = false
    },

    beforeWindowUnload (e) {
      if (this.inventoryChangeMap.size) {
        let confirmationMessage = this.translations('inventory.notice_results_displayed_may_disappear')
        e.returnValue = confirmationMessage
        return confirmationMessage
      }
    },

    debounceSaveSession () {
      this.isSearching = true
      if (this.timeOutId) clearTimeout(this.timeOutId)
      this.timeOutId = setTimeout(this.saveDataWhenFilter, 10 * 1000)
    },

    async getCacheDataWithFilter () {
      this.isSearching = true
      const params = {
        key: [format(new Date(this.inventory_at), 'yyyy/MM/dd'), this.warehouse_id, this.selectedCondition, this.personal_id, this.status_id, this.isDifference ? 1 : 0].join('-')
      }
      try {
        const {
          data: { status, data }
        } = await this.$http.post(this.$api_url.inventory_get_session, params)
        if (status) {
          if (this.status_id > 0 || this.isDifference) {
            let tempInventories = this.inventories
            tempInventories.forEach((item) => {
              data.data.forEach((prevInventory) => {
                if (item.product_id === prevInventory.product_id) item.real_quantity = prevInventory.real_quantity
              })
            })
            this.inventories = tempInventories
          } else {
            this.inventories = data.data
          }
        } else {
          throw new Error('Something went wrong.')
        }
      } catch (error) {}
      this.isSearching = false
    },

    async saveDataWhenFilter (oldCondition) {
      this.isSearching = true

      let inventories = []
      if (this.status_id === inventoryStatus.PROCESSED || this.isDifference) {
        inventories = this.filterInventories.filter(item => {
          return item.real_quantity !== item.original_quantity
        })
      } else if (this.isDifferenceLocal) {
        let dataChange = this.filterInventories.filter((inventory) => inventory.real_quantity !== inventory.original_quantity)
        let dataNoExist = this.tempInventories.filter((inventory) => {
          return (inventory.real_quantity - inventory.amount) === 0
        })
        inventories = this.mergeArrays(dataNoExist.concat(dataChange), ['jan_code', 'item_no', 'legacy_code', 'amount'])
      } else if (!this.isScanBarCode) {
        inventories = this.filterInventories.filter(item => {
          return item.real_quantity
        })
      } else {
        inventories = this.filterInventories
      }

      inventories.forEach((inventory) => { inventory.quantity = inventory.real_quantity })

      try {
        const params = {
          date: format(new Date(this.inventory_at), 'yyyy/MM/dd'),
          condition: oldCondition || this.selectedCondition,
          warehouse_id: this.warehouse_id,
          process_status: this.status_id,
          personal_id: this.personal_id,
          is_diff: this.isDifference ? 1 : 0,
          value: this.filterPropInventory(inventories)
        }
        let $data = await this.$http.post(
          this.$api_url.inventory_save_session,
          params
        )

        if ($data.data.status) {
          this.isSearching = false
          await this.getCacheDataWithFilter()
        }
        this.isSearching = false
      } catch (error) {}
      this.isSearching = false
    },
    async submitSearch () {
      await this.getCacheDataWithFilter()
      if (this.status_id > 0) {
        await this.listInventories()
      }
    },
    mergeArrays (inventories, keys) {
      const map = new Map()
      inventories.forEach(item => {
        const uniqueKey = keys.map(key => item[key]).join('|')
        map.set(uniqueKey, item)
      })

      return Array.from(map.values())
    }
  }
}
</script>

<style>
.real-quantity {
  font-weight: bold;
  padding-left: 12px;
}

.wrap-edit {
  position: relative;
}

.edit-input {
  max-height: 150px;
  opacity: 0;
}

.edit-input:focus + .show-text {
  opacity: 0;
}

.show-text {
  opacity: 1;
  border: 1px solid #ccc;
  height: calc(2.0625rem + 2px);
  position: absolute;
  top: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 6px 12px;
  background-color: #fff;
  border-radius: 0.25rem;
}

.wrap-edit:focus-within > .show-text {
  opacity: 0;
}

.wrap-edit:focus-within > .edit-input {
  opacity: 1;
}

@media screen and (max-width: 1366px) {
  .checkbar-group {
    display: flex;
    margin-bottom: 10px !important;
    align-items: center;
  }

  .checkbar-label {
    display: flex;
    flex-direction: column;
    margin: 0 1rem 0 0;
    min-width: 125px;
  }
}

</style>

<style scoped>
@media screen and (max-width: 1366px) {
  .input-150px {
    max-width: 150px;
  }
}
</style>
